 // Scripting to handle tabs interaction
 (function ($) {

   //Stop propagation on linked card anchor clicks
   $(document).on('click', '.linked-card a', function (e) {
     //$('.card.linked-card a, .card.no-excerpt a').click(function(e) {
     e.preventDefault();
   });

   //Capture card clicks outside of the anchors
   $(document).on('click', '.linked-card', function (e) {
     //$('.card.linked-card').click(function(e) {
     let $card = $(this).hasClass('linked-card') ? $(this) : $(this).parents('.linked-card');
     let $anchor = $card.find('a').first();

     if ($anchor) {
       handleCardAnchorClick($anchor);
     }

   });

    //Centralized handling of the card clicks
    function handleCardAnchorClick($anchor) {
      //Modals have to trigger a special event to avoid recursive clicking
      if ($anchor.hasClass('open-popup-link')) {
        $anchor.trigger('modalclick');
      }
      else if ($anchor.attr('target') == '_blank') {
        window.open($anchor.attr('href'));
      }
      else {
        window.location = $anchor.attr('href');
      }
    }

 })(jQuery);
